import { render } from "./lei-request.vue?vue&type=template&id=df9197e0&scoped=true&ts=true"
import script from "./lei-request.vue?vue&type=script&lang=ts"
export * from "./lei-request.vue?vue&type=script&lang=ts"

import "./lei-request.vue?vue&type=style&index=0&id=df9197e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df9197e0"]])

export default __exports__